import { useAtomData, USER_DATASOURCE } from '@lighthouse/shared'
import { useMemo } from 'react'

import { userRecordAtom } from '@/atoms/dataSource/state'

import { useCurrentAppId, useCurrentEnvId } from './useApplication'
import { useDataSource } from './useDataSource'

export const useUserRecord = function () {
    const appId = useCurrentAppId()
    const envId = useCurrentEnvId()
    const datasource = useDataSource(appId, envId, USER_DATASOURCE)
    const currentRecord = useAtomData(userRecordAtom)

    return useMemo(() => ({ datasource, record: currentRecord }), [currentRecord, datasource])
}
